import {
  valueSet,
  valueTargeSet,
  valueTargeArraySet,
  atCostAddItem,
  atCostremoveItem,
  valueResetSet,
} from './common'

const claimParentsState = () => ({
  data: {
    child: {},
    office: {},
    dateNowW: '',
    dateNowY: '',
    dateNowM: '',
    dateNowD: '',
    invoiceNo: '',
    billingDateNowW: '',
    billingDateNowY: '',
    billingDateNowM: '',
    receiptDate: '',
    batDecisionUbCost: '',
    batTotalCost: '',
    details: [],
    visitDetails: [],
    batUnits: '',
    batBillingAmount: '',
    atCostSummary: '',
    atCost: [],
    billingAmount: '',
    useDay: '',
    inputSelectNowDate: '',
    inputPrevNowDate: '',
    batBillingGrantMunicipal: '',
    visitBatUnits: '',
    visitBatTotalCost: '',
    visitBatBillingAmount: '',
    visitBatBillingGrantMunicipal: '',
    notesForParentRequest: '',
    notesForParentRequestPrev: '',
  },
})

export default {
  namespaced: true,
  state: claimParentsState(),
  mutations: {
    valueResetSet,
    valueSet,
    valueTargeSet,
    valueTargeArraySet,
    atCostAddItem,
    atCostremoveItem,
  },
}
